const userRoles = ["admin", "leader", "manager", "member"]

/**
 *
 * @param users UserType[]
 * @returns
 */
export function buildUserList(users: UserType[]): UserType[] {
  return Object.keys(users)
    .map((key) => users[key])
    .filter((user) => {
      return userRoles.includes(user.role)
    })
}
